var modules_3717c142 = {"container":"_q5ihey","color-blue":"_1xk4f41","color-gray":"_1rwqn9s","color-dark":"_b81gcm","strong":"_1g948bd"};
import "../../../assets/Cf5Iucnn.css";

export { modules_3717c142 as default };
//# sourceMappingURL=Link.module.less.js.map
